import { useEffect, type ReactNode } from 'react';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, login } = useAuth();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      const returnTo =
        window.location.pathname + window.location.search + window.location.hash;
      login(returnTo);
    }
  }, [isAuthenticated, isLoading, login]);

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center bg-ivory">
        <div className="flex flex-col items-center gap-3 text-bark">
          <div
            className="h-6 w-6 animate-spin rounded-full border-2 border-fog border-t-gold"
            aria-hidden
          />
          <p className="text-sm">Signing you in…</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="flex h-full items-center justify-center bg-ivory text-bark">
        <p className="text-sm">Redirecting to sign-in…</p>
      </div>
    );
  }

  return <>{children}</>;
}
